module.exports = __webpack_public_path__ + "media/offers/offer-poziom-black@2x-845f6520.png";